/* eslint-disable jsx-a11y/heading-has-content */
import React, { useState } from "react";
import { Layout } from "../components/Layout";

export const CallCenter = () => {
	const source = require("../data/callCenter.json");
	const data = source["diseases"];
	const data2 = source["psychiatry"];
	const [activeCategory, setActiveCategory] = useState(null);

	const contactCards = [
		{ icon: "fas fa-user-md", label: "Office Manager", number: "08065209446", color: "#37514B" },
		{ icon: "fas fa-heartbeat", label: "Nursing Coordinator", number: "08130790883", color: "#00b8b8" },
		{ icon: "fas fa-briefcase", label: "Project Manager", number: "09024000024", color: "#4a6d65" },
		{ icon: "fas fa-headset", label: "Customer Care", number: "08065209446", color: "#253832" },
	];

	return (
		<Layout
			subtitle={""}
			title={"24/7 doctors on call service"}
			bgimage={require("../media/images/e-health/call-center.jpg").default}
			jumpto="services"
		>
			{/* ── Intro + Contact Numbers ── */}
			<section
				id="services"
				style={{
					padding: "5rem 0",
					background: "linear-gradient(180deg,#f0f9f9 0%,#fff 100%)",
					position: "relative",
					overflow: "hidden",
				}}
			>
				<div style={{ position: "absolute", width: 500, height: 500, background: "rgba(0,184,184,0.07)", borderRadius: "50%", filter: "blur(80px)", top: -150, right: -150, pointerEvents: "none" }} />
				<div style={{ position: "absolute", width: 350, height: 350, background: "rgba(55,81,75,0.07)", borderRadius: "50%", filter: "blur(60px)", bottom: -80, left: -100, pointerEvents: "none" }} />

				<div className="container" style={{ position: "relative", zIndex: 1 }}>
					<div className="row align-items-center g-5">
						{/* Text */}
						<div className="col-12 col-lg-6">
							<div className="section-tag">24/7 On-Call</div>
							<div className="accent-line" style={{ margin: "1rem 0 1.5rem" }} />
							<h2 className="section-title-modern" style={{ marginBottom: "1.25rem" }}>
								You Call, <span>We Answer</span>
							</h2>
							<p style={{ color: "#4b5563", lineHeight: 1.8, fontSize: "1rem", marginBottom: "1rem" }}>
								Call our doctors on call for immediate medical questions and management of your medical conditions wherever you are and at your convenience.
							</p>
							<p style={{ color: "#4b5563", lineHeight: 1.8, fontSize: "1rem", marginBottom: "2rem" }}>
								If your condition cannot be managed over the phone, our doctors on call will either refer you to the nearest hospital in your area or assist you with scheduling an appointment with a specialist.
							</p>
							<div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
								<a href="tel:08130790883" className="btn-modern-primary">
									<i className="fas fa-phone-alt" />
									<span>Call Us Now</span>
								</a>
								<a href="/contact" className="btn-modern-outline">
									<span>Send a Message</span>
								</a>
							</div>
						</div>

						{/* Contact cards */}
						<div className="col-12 col-lg-6">
							<div className="row g-3">
								{contactCards.map((card, i) => (
									<div key={i} className="col-12 col-sm-6 mt-3">
										<a
											href={`tel:${card.number}`}
											style={{
												display: "flex",
												alignItems: "center",
												gap: "1rem",
												background: "#fff",
												borderRadius: 16,
												padding: "1.25rem 1.5rem",
												boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
												border: "1px solid rgba(0,184,184,0.1)",
												textDecoration: "none",
												transition: "all 0.3s ease",
												animationDelay: `${i * 0.1}s`,
											}}
											onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-5px)"; e.currentTarget.style.boxShadow = "0 15px 40px rgba(0,0,0,0.12)"; }}
											onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 30px rgba(0,0,0,0.08)"; }}
										>
											<div style={{ width: 46, height: 46, borderRadius: 12, background: `${card.color}18`, display: "flex", alignItems: "center", justifyContent: "center", color: card.color, fontSize: "1.1rem", flexShrink: 0 }}>
												<i className={card.icon} />
											</div>
											<div>
												<div style={{ fontSize: "0.75rem", color: "#9ca3af", fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>{card.label}</div>
												<div style={{ fontSize: "0.95rem", fontWeight: 700, color: "#1a2332" }}>{card.number}</div>
											</div>
										</a>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* ── Services We Treat ── */}
			<section style={{ padding: "4rem 0 5rem", background: "#fff", position: "relative" }}>
				<div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: "linear-gradient(90deg,#37514B,#00b8b8,#37514B)", backgroundSize: "200% auto", animation: "borderFlow 3s linear infinite" }} />
				<div className="container">
					<div className="row justify-content-center" style={{ marginBottom: "3rem" }}>
						<div className="col-12 col-lg-7 text-center">
							<div className="section-tag">What We Treat</div>
							<div className="accent-line accent-line-center" style={{ margin: "1rem auto 1.5rem" }} />
							<h2 className="section-title-modern">
								Medical <span>Services</span>
							</h2>
							<p style={{ color: "#6b7280", lineHeight: 1.8 }}>
								Our qualified and experienced physicians are ready to manage a wide range of conditions.
							</p>
						</div>
					</div>

					{/* Category tabs */}
					<div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", justifyContent: "center", marginBottom: "2.5rem" }}>
						<button
							onClick={() => setActiveCategory(null)}
							style={{
								padding: "0.6rem 1.5rem",
								borderRadius: 50,
								border: "2px solid",
								borderColor: activeCategory === null ? "#37514B" : "rgba(0,0,0,0.1)",
								background: activeCategory === null ? "#37514B" : "transparent",
								color: activeCategory === null ? "#fff" : "#374151",
								fontWeight: 600,
								fontSize: "0.85rem",
								cursor: "pointer",
								transition: "all 0.3s ease",
							}}
						>
							All Categories
						</button>
						{Object.keys(data).map((cat, i) => (
							<button
								key={i}
								onClick={() => setActiveCategory(cat)}
								style={{
									padding: "0.6rem 1.5rem",
									borderRadius: 50,
									border: "2px solid",
									borderColor: activeCategory === cat ? "#00b8b8" : "rgba(0,0,0,0.1)",
									background: activeCategory === cat ? "#00b8b8" : "transparent",
									color: activeCategory === cat ? "#fff" : "#374151",
									fontWeight: 600,
									fontSize: "0.85rem",
									cursor: "pointer",
									transition: "all 0.3s ease",
								}}
							>
								{cat}
							</button>
						))}
					</div>

					{/* Disease grid */}
					{Object.entries(data)
						.filter(([cat]) => activeCategory === null || cat === activeCategory)
						.map(([cat, items], ci) => (
							<div key={ci} style={{ marginBottom: "3rem" }}>
								<div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1.5rem" }}>
									<div style={{ width: 40, height: 40, borderRadius: 10, background: "linear-gradient(135deg,#37514B,#00b8b8)", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", flexShrink: 0 }}>
										<i className="fas fa-stethoscope" style={{ fontSize: "0.9rem" }} />
									</div>
									<h4 style={{ fontWeight: 700, color: "#1a2332", margin: 0, fontSize: "1.1rem" }}>{cat}</h4>
									<div style={{ flex: 1, height: 1, background: "linear-gradient(90deg,rgba(0,184,184,0.3),transparent)" }} />
								</div>
								<div className="row">
									{Object.entries(items).map(([name, img], ii) => (
										<div key={ii} className="col-6 col-md-4 col-lg-3" style={{ marginBottom: '1rem' }}>
											<div
												style={{
													borderRadius: 16,
													overflow: "hidden",
													position: "relative",
													height: 160,
													boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
													transition: "all 0.4s ease",
													cursor: "default",
												}}
												onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-6px)"; e.currentTarget.style.boxShadow = "0 20px 50px rgba(0,0,0,0.18)"; }}
												onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "0 8px 25px rgba(0,0,0,0.1)"; }}
											>
												<img
													src={require(`../media/diseases/${img}`).default}
													alt={name}
													style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.5s ease" }}
												/>
												<div style={{ position: "absolute", inset: 0, background: "linear-gradient(to top,rgba(0,0,0,0.75) 0%,rgba(0,0,0,0.1) 60%,transparent 100%)" }} />
												<div style={{ position: "absolute", bottom: 0, left: 0, right: 0, padding: "0.75rem 1rem" }}>
													<div style={{ color: "#fff", fontWeight: 600, fontSize: "0.8rem", lineHeight: 1.3, textShadow: "0 1px 4px rgba(0,0,0,0.5)" }}>{name}</div>
												</div>
											</div>
										</div>
									))}
								</div>
							</div>
						))}
				</div>
			</section>

			{/* ── Psychiatry ── */}
			<section style={{ padding: "4rem 0 5rem", background: "linear-gradient(180deg,#f0f9f9 0%,#fff 100%)" }}>
				<div className="container">
					<div className="row align-items-center g-5">
						<div className="col-12 col-lg-5">
							<div className="section-tag">Mental Health</div>
							<div className="accent-line" style={{ margin: "1rem 0 1.5rem" }} />
							<h2 className="section-title-modern" style={{ marginBottom: "1.5rem" }}>
								<span>Psychiatry</span> Services
							</h2>
							<p style={{ color: "#4b5563", lineHeight: 1.8, marginBottom: "2rem" }}>
								Mental health is as important as physical health. Our qualified psychiatrists and mental health professionals are available to support you.
							</p>
							<div style={{ display: "flex", flexWrap: "wrap", gap: "0.75rem" }}>
								{Object.entries(data2).map(([name], i) => (
									<div
										key={i}
										style={{
											padding: "0.5rem 1rem",
											background: "rgba(0,184,184,0.08)",
											border: "1px solid rgba(0,184,184,0.2)",
											borderRadius: 50,
											fontSize: "0.82rem",
											color: "#37514B",
											fontWeight: 600,
										}}
									>
										{name}
									</div>
								))}
							</div>
						</div>
						<div className="col-12 col-lg-7">
							<div style={{ borderRadius: 24, overflow: "hidden", boxShadow: "0 30px 80px rgba(0,0,0,0.15)" }}>
								<img
									src={require("../media/diseases/PSYCHIATRY.png").default}
									alt="Psychiatry"
									style={{ width: "100%", display: "block", maxHeight: 400, objectFit: "cover" }}
								/>
							</div>
						</div>
					</div>
				</div>
			</section>

			{/* ── CTA ── */}
			<section style={{ padding: "4rem 0 5rem", background: "linear-gradient(135deg,#253832 0%,#37514B 50%,#1a4a42 100%)", position: "relative", overflow: "hidden" }}>
				<div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(rgba(0,184,184,0.08) 1px,transparent 1px)", backgroundSize: "32px 32px", pointerEvents: "none" }} />
				<div className="container" style={{ position: "relative", zIndex: 1 }}>
					<div className="row justify-content-center text-center">
						<div className="col-12 col-lg-7">
							<h2 style={{ color: "#fff", fontWeight: 800, fontSize: "clamp(1.5rem,4vw,2.2rem)", marginBottom: "1rem", lineHeight: 1.3 }}>
								Ready for immediate medical assistance?
							</h2>
							<p style={{ color: "rgba(255,255,255,0.75)", marginBottom: "2rem", fontSize: "1rem" }}>
								Our doctors are standing by 24 hours a day, 7 days a week.
							</p>
							<div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap" }}>
								<a href="tel:08130790883" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "#fff", color: "#37514B", padding: "1rem 2rem", borderRadius: 50, fontWeight: 700, textDecoration: "none", boxShadow: "0 8px 25px rgba(0,0,0,0.2)", transition: "all 0.3s ease", fontSize: "0.95rem" }}
									onMouseEnter={(e) => { e.currentTarget.style.transform = "translateY(-3px)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.transform = "translateY(0)"; }}>
									<i className="fas fa-phone-alt" /> 08130790883
								</a>
								<a href="/service/call-service" style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.12)", border: "2px solid rgba(255,255,255,0.3)", color: "#fff", padding: "1rem 2rem", borderRadius: 50, fontWeight: 600, textDecoration: "none", transition: "all 0.3s ease", fontSize: "0.95rem" }}
									onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.2)"; }}
									onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(255,255,255,0.12)"; }}>
									<i className="fas fa-arrow-right" /> Learn More
								</a>
							</div>
						</div>
					</div>
				</div>
			</section>
		</Layout>
	);
};
